import { Component, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrl: './reset-password.component.scss',
    encapsulation: ViewEncapsulation.None,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        NgIf,
    ],
})
export class ResetPasswordComponent {
  form!: FormGroup;
  mode: 'request' | 'confirm' = 'request';
  message: string | null = null;
  loading = false;
  token: string | null = null;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.token = this.route.snapshot.queryParamMap.get('token');
    this.mode = this.token ? 'confirm' : 'request';

    this.form =
      this.mode === 'request'
        ? this.fb.group({
            email: ['', [Validators.required, Validators.email]],
          })
        : this.fb.group({
            newPassword: ['', [Validators.required, Validators.minLength(6)]],
          });
  }

  submit() {
    this.loading = true;
    this.message = null;

    if (this.mode === 'request') {
      const email = this.form.value.email;
      this.authService.resetPassword(email).subscribe({
        next: () => {
          this.message = 'If this email exists, a reset link has been sent.';
          this.loading = false;
        },
        error: (err) => {
          this.message = err.error || 'Failed to send reset email.';
          this.loading = false;
        },
      });
    } else {
      const newPassword = this.form.value.newPassword;
      this.authService
        .confirmResetPassword(this.token!, newPassword)
        .subscribe({
          next: () => {
            this.message = 'Password has been reset successfully.';
            setTimeout(() => this.router.navigate(['/login']), 1500);
          },
          error: (err) => {
            this.message = err.error || 'Failed to reset password.';
            this.loading = false;
          },
        });
    }
  }
}
